import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context/AuthContext";
import axios from "axios";

const Navbar = (props) => {
    const { t } = useTranslation();
    const { user } = useAuth();
    const [logo, setLogo] = useState("");

    // Bildirim stateleri
    const [unreadCount, setUnreadCount] = useState(0);
    const currentUserId = user.user?.id || user?.nameid;

    const getlogo = async () => {
        try {
            const headerss = {
                accept: "*/*",
                "Content-Type": "application/json",
            };

            await axios({
                method: "get",
                url: "https://express.heryerdeingilizce.com/getlogo",
                headers: headerss,
            }).then((res) => {
                setLogo(res.data[0]);
            });
        } catch (err) { }
    };

    // Okunmamış mesaj sayısını çeken fonksiyon
    const fetchUnreadCount = async () => {
        if (!currentUserId) return;
        try {
            // Kendi backend adresinize göre burayı güncelleyin
            const res = await axios.get(`https://express.heryerdeingilizce.com/api/messages/unread-count/${currentUserId}`);
            if (res.data.success) {
                setUnreadCount(res.data.count);
            }
        } catch (error) {
            console.error("Bildirim sayısı alınamadı:", error);
        }
    };

    useEffect(() => {

        getlogo();
        fetchUnreadCount();

        // Arka planda her 60 saniyede bir yeni mesaj var mı diye kontrol et (Gerçek zamanlı hissiyatı verir)
        const interval = setInterval(() => {
            fetchUnreadCount();
        }, 60000);

        // Component ekrandan kalkarsa interval'i temizle
        return () => clearInterval(interval);
    }, [currentUserId]);

    return (
        <nav
            className="navbar navbar-expand-sm bg-body-tertiary py-0"
            style={{ backgroundColor: "white", borderBottom: " solid #e9ecef" }}
        >
            <div
                className="container-fluid d-flex align-items-center justify-content-between"
                style={{ backgroundColor: "white", minHeight: 72 }}
            >
                <a className="navbar-brand d-flex align-items-center py-0" href="/">
                    {logo && (
                        <img
                            src={logo["photo"]}
                            alt="logo"
                            style={{ maxWidth: "220px", maxHeight: "72px" }}   // 🔥 80 -> 46
                            className="img-fluid"
                        />
                    )}
                </a>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-0"></ul>

                    <div className="d-flex align-items-center" style={{ gap: "25px" }}>

                        {/* BİLDİRİM (ZİL) İKONU */}
                        <a
                            href="/messages"
                            className="text-decoration-none position-relative mt-1"
                            style={{ color: "#555" }}
                            title="Mesajlar ve Duyurular"
                        >
                            <i className="fa fa-bell" style={{ fontSize: "22px" }}></i>
                            {unreadCount > 0 && (
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: "0.65em" }}>
                                    {unreadCount}
                                    <span className="visually-hidden">okunmamış mesaj</span>
                                </span>
                            )}
                        </a>

                        {/* PROFİL BİLGİSİ */}
                        <a
                            href="/profile"
                            className="d-flex align-items-center text-decoration-none"
                            style={{ gap: 10, color: "inherit" }}
                        >
                            <i
                                className="fa fa-user-circle"
                                style={{ fontSize: 36, lineHeight: 1, color: "#6c757d" }}
                                aria-hidden="true"
                            />
                            <span style={{ lineHeight: 1.10 }}>
                                <strong>{user?.user?.["fullName"]}</strong>
                                <br />
                                <span style={{ fontSize: "0.85em", color: "#6c757d" }}>{user?.role}</span>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;